<template>
  <div></div>
</template>

<script>
import _env from '../../config/dev.env.var.js';
// import envSetting from '../../config/env.setting'

import { markRaw, toRaw } from 'vue';
import L from 'leaflet';
import "../../node_modules/leaflet/dist/leaflet.css";
import "leaflet.vectorgrid"

export default {
    name: 'vlayer',
    data () {
      return {
        vectorTileCache: markRaw({}),
        vectorTile: null,
        data: {},
        layerCacheKeys: markRaw([]),
        isCachedLayer: false, // 現在vectorTileに格納されているTileがvectorTileCacheに格納されているTileかどうか
        prevLayer: null,
        lastColoredMeshes: markRaw([]),
        localOpacity: 1,
        features: markRaw([]),
        meshHasData: markRaw([]),
        updateLayerTimer: null,
        updateRunId: 0
      }
    },
    mounted: function () {
    },
    beforeUnmount () {
      if (this.updateLayerTimer) {
        clearTimeout(this.updateLayerTimer)
      }
    },
    computed: {
            sharedState () {
                return this.$store.state
            },
            latestUpdate () {
                return this.$store.latestUpdate
            },
            cityName () {
                return this.sharedState.cityName
            },
            map () {
                return this.sharedState.map
            },
            selectedLayer: {
              get () {
                return this.sharedState.selectedLayer
              },
              set (value) {
                this.$store.commit('setSelectedLayer', value)
              }
            },
            numData () {
                return this.sharedState.numData
            },
            threshold () {
                return this.sharedState.thresholds
            },
            config () {
                return this.sharedState.config_from_api
            },
            year () {
                return this.$store.state.year
            },
            opacity () {
                return this.sharedState.tileOpacity
            },
            mapChangeEvent () {
                return this.sharedState.mapChangeEvent
            },
            meshShowFlag () {
              return this.sharedState.meshShowFlag
            }
        },
    watch: {
            mapChangeEvent: function () {
              this.scheduleUpdateLayerChain()
            },
            config: function () {
              // this.updateLayerChain()
            },
            selectedLayer: function (newval, oldval) {
              this.scheduleUpdateLayerChain(0)
            },
            year: function () {
              this.scheduleUpdateLayerChain(0)
            },
            // タイムスライダー対応
            opacity: function (newval, oldval) {
              this.changeOpacity(newval)
            },
            latestUpdate: function () {
              this.changeMeshStyle()
            },
            meshShowFlag: function (val) {
              if (val == true){
                this.changeOpacity(1)
              }else{
                this.changeOpacity(0)
              }
            },
        },
    methods: {
        scheduleUpdateLayerChain(delay = 150) {
          if (this.updateLayerTimer) {
            clearTimeout(this.updateLayerTimer)
          }

          this.updateLayerTimer = setTimeout(() => {
            this.updateLayerTimer = null
            this.updateLayerChain()
          }, delay)
        },
        updateLayerChain(){
          const runId = ++this.updateRunId
          this.$store.commit('chgLoadingModalVisible', true)
          this.fetchGeoBufLayer(this.selectedLayer)
                // TODO: 統計データ取得
                .then(() => {
                    if (runId !== this.updateRunId) {
                      return
                    }
                    this.fetchNumData({dataID: this.selectedLayer})
                    .then(() => {
                      if (runId !== this.updateRunId) {
                        return
                      }
                      if(this.numData && Object.keys(this.numData).length > 0) {
                        this.changeMeshStyle()
                      }
                      this.$store.commit('chgLoadingModalVisible', false)
                    })
                })
        },
        async fetchNumData (args) {
            let mapBounds = this.getMapBounds()
            console.log(mapBounds)
            await this.$store.dispatch('fetchNumData', {"dataID":args.dataID, "timeIdx": args.timeIdx, "mapBounds": mapBounds})
        },
        async fetchGeoBufLayer (layerID) {
          this.isCachedLayer = false
          this.prevLayer = this.vectorTile ? markRaw(toRaw(this.vectorTile)) : null
          
          this.$store.commit('updateMeshLayer', this.prevLayer)

          let pbf_url = this.config.tileSevers['population-base-map'][layerID][this.year]
          let layerCacheKey = pbf_url
          if (this.layerCacheKeys.includes(layerCacheKey)){
            this.vectorTile = markRaw(toRaw(this.vectorTileCache[layerCacheKey]))
            this.isCachedLayer = true
          }else{
            let prop_name

            if (layerID == 2) {
              prop_name = 'KEY_CODE'
            } else {
              prop_name = 'GRID_CODE'
            }

            let cityName = this.cityName
            let style1 = {
              stroke: false,
            }
            let style2 = {
              stroke: false,
              fillColor: 'yellow',
              fill: true
            }
            let style3 = {
              stroke: true,
              weight: 0.3,
              fillColor: 'yellow',
              fill: true
            }
            let style_hide = {
              stroke: false,
              fill: false,
            }

            const vectorTile = markRaw(L.vectorGrid.protobuf(pbf_url, {
              attribution: "attribution",
              zIndex: 100,
              maxNativeZoom: 14,
              minNativeZoom: 10,
              maxZoom: 18,
              rendererFactory: L.canvas.tile,
              // interactiveをtrueにすると，よりメモリを消費する
              interactive: false,
              opacity: this.opacity,
              getFeatureId: function(f) {
                return String(f.properties[prop_name])
              },
              vectorTileLayerStyles: {
                "japan_500m_mesh": style_hide,
                "h12ka34": style_hide,
                "h17ka34": style_hide,
                "h22ka34": style_hide,
                "h27ka33": style_hide,
                "h27ka34": style_hide,
                "gs_map": style_hide,
              },
            }))

            // TODO: infoWindowイベントを仕込む
            // 二回目以降のクリック時にイベントを取得できないため，Map.vueでクリックイベントを取得する方向に変更
            // vectorTile.on('click', (e) => {
            //   console.log("vectorTile-クリック")
            //   // L.DomEvent.stopPropagation(e) //map へclick eventを伝搬しない
            //   console.log(e)

            //   this.$store.commit('setSelectedMarker', {
            //     name: "vectorTileクリック",
            //     address: "lat: "+e.latlng.lat+"lon"+e.latlng.lng,
            //     lat: e.latlng.lat,
            //     lon: e.latlng.lng,
            //     category: ""
            //   })

            //   // TODO:サークル描画．描画が上手く走らない
            //   // クリック時にマーカーの下にサークルを描画
            //   const circle = L.circle([e.latlng.lat, e.latlng.lng], parseInt(this.sharedState.circleRange));
            //   this.$store.commit('addLayer', circle)
            //   this.$store.commit('setCircle', circle)

            //   this.openInfoWindow(e)
            // })
            this.layerCacheKeys.push(layerCacheKey)
            vectorTile["property"] = "tile"
            this.vectorTileCache[layerCacheKey] = vectorTile
            this.vectorTile = vectorTile
            this.$store.commit('addLayer', vectorTile)
          }
        },
        meshStyle (id, total) {
          let color = 'white'

          // TODO: 閾値に沿った色を取得する。
          for (let i = 0; i < this.threshold.length; i++) {

            if (i == 0) {
              continue
            }

            if (total < this.threshold[i].value) {
              // 到達しなければ決定
              color = this.threshold[i-1].color
              break;

            } else {

              // 暫定で現在のループで一番上の色をセット（より上にヒットすればループ内で上書きされる)
              color = this.threshold[i].color
            }
          }
          if (color !== 'white' && color !== 'rgba(100, 100, 100, 0.8)'){
            this.meshHasData.push(id)
          }
          return {
            stroke: false,
            fill: true,
            fillColor: color,
            fillOpacity: 1,
          }
        },
        changeMeshStyle () {
          const vectorTile = toRaw(this.vectorTile)
          if (!vectorTile) {
            return
          }
          // 直前に彩色したメッシュの色を消す。（同じvectorTileを使いまわす場合：メッシュなど）
          if (this.prevLayer == this.vectorTile || this.prevLayer == null){
            let prevLayer = this.prevLayer ? toRaw(this.prevLayer) : null
            let lastColoredMeshes = this.lastColoredMeshes
            if (prevLayer != undefined) {
              lastColoredMeshes.forEach( meshId => {
                prevLayer.setFeatureStyle(meshId, {
                  stroke: false,
                  fill: false,
                });
              })
            }
          //異なるvectorTileの場合メッシュの色を消すよりもdisplay:noneにした方が速い 
          }else{
            let localOpacity = this.localOpacity
            this.changeOpacity(0, this.prevLayer)
            this.changeOpacity(1, this.vectorTile)
            this.localOpacity = localOpacity
            // キャッシュ済のvectorTileなら既に色塗りは終わっているので，色塗りせずに終了
            if (this.isCachedLayer == true){
              this.changeOpacity(this.localOpacity) // layerを非表示にした状態でlayer切替が起こった場合の対応
              return
            }
          }

          this.lastColoredMeshes = markRaw([])
          this.meshHasData = markRaw([])
          for (let [key, value] of Object.entries(this.numData)) {
            // タイムスライダー時に前回の色を消すために保持
            this.lastColoredMeshes.push(key)
            vectorTile.setFeatureStyle(key, this.meshStyle(key, value));
          }
          this.$store.commit('setNumData', null)
          this.changeOpacity(this.localOpacity) // layerを非表示にした状態でlayer切替が起こった場合の対応
        },
        // デフォルト引数はvectorTile(現在表示中のタイル)
        changeOpacity (opacity, vt = this.vectorTile) {
          this.localOpacity = opacity
          const layer = toRaw(vt)
          if (!layer || !layer._container) {
            return
          }
          // opacityを設定するメソッドを使う方法
          // this.vectorTile.setOpacity(opacity);
          
          // display:noneを使って隠す方法（高速）
          if (opacity == 0){
            layer._container.style.display = 'none'
          }else{
            layer._container.style.display = ''
          }
        },
        openInfoWindow(event) {
          this.$store.commit('chgInfoWindowVisible', true) // open InfoWindow
        },
        getMapBounds (){
          return toRaw(this.$store.state.map).getBounds()
        },

        isEmpty(val){
          if (!val){//null or undefined or ''(空文字) or 0 or false
            if ( val !== 0 && val !== false ) {
              return true;
            }
          }else if( typeof val == "object"){//array or object
            console.log(Object.keys(val).length === 0)
            return Object.keys(val).length === 0;
          }

          return false;//値は空ではない
        },
        latlon2xyz(lat, lon, level) {
          // degrees2meters
          var x = lon * 20037508.34 / 180.0;
          var y = Math.log(Math.tan((90.0 + lat) * Math.PI / 360.0)) / (Math.PI / 180.0);
          y = y * 20037508.34 / 180.0;
          const GEO_R = 6378137;
          const orgX = -1 * (2 * GEO_R * Math.PI / 2);
          const orgY = (2 * GEO_R * Math.PI / 2);
          let xy = [x,y]
          let unit = 2 * GEO_R * Math.PI / Math.pow(2, level)
          let xtile = Math.floor((xy[0] - orgX) / unit);
          let ytile = Math.floor((orgY - xy[1]) / unit);
          
          return [xtile, ytile, level]
        },
        getTileXYZs() {
          let bounds = this.sharedState.map.getBounds()
          let zoom = Math.floor(this.sharedState.map.getZoom())
          let nw = this.latlon2xyz(bounds["_northEast"]["lat"], bounds["_southWest"]["lng"], zoom)
          let se = this.latlon2xyz(bounds["_southWest"]["lat"], bounds["_northEast"]["lng"], zoom)
          var tileXYZs = []
          for (let x=nw[0]; x<=se[0]; x++){
            for (let y=nw[1]; y<=se[1]; y++){
              tileXYZs.push({"x":x, "y":y, "z":zoom, "t":this.sharedState.year})
            }
          }
          return tileXYZs
        },
    }
}
</script>

<style>

</style>
